import type { PromoUploadStatusType } from '@entities/adCampaign';

export const getReorderedVideoPromos = (current: PromoUploadStatusType[], next: PromoUploadStatusType[]) => {
  const byId = new Map(current.map((item) => [item.id, item]));
  const nextIds = new Set(next.map((item) => item.id));
  if (
    next.length !== current.length ||
    nextIds.size !== current.length ||
    next.some((item) => !item.id || !byId.has(item.id)) ||
    next.every((item, index) => item.id === current[index].id)
  )
    return undefined;
  return next.map((item) => byId.get(item.id)!);
};
